var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", {
      domProps: { innerHTML: _vm._s(_vm.$t("landing_page.welcome_text")) },
    }),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(_vm.$t("landing_page.activation_code_reminder")),
      },
    }),
    _c("p", {
      domProps: { innerHTML: _vm._s(_vm.$t("landing_page.continue_text")) },
    }),
    _c(
      "div",
      { staticClass: "actionBar" },
      [
        _c("router-link", {
          staticClass: "keyloopButton textUppercase",
          attrs: {
            to: { name: "Login", params: { lang: _vm.$i18n.locale } },
            tag: "button",
            id: "startButton",
          },
          domProps: { innerHTML: _vm._s(_vm.$t("global.start")) },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }